import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import ImgResponsive from './ImgResponsive';

const ads1 = "/images/GrpImages/GrpImages-13.jpg";
const ads2 = "/images/GrpImages/GrpImages-14.jpg";
const ads3 = "/images/GrpImages/GrpImages-15.jpg";
const ads4 = "/images/GrpImages/GrpImages-16.jpg";
const ads5 = "/images/GrpImages/GrpImages-17.jpg";

const CarouselReview: React.FC = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <Box sx={{ width: '98%', margin: '0 auto', padding: '10px 2px 2px 2px' }}>
      <Slider {...settings}>
        <div>
          <ImgResponsive src={ads1} alt="Slide 1" />
        </div>
        <div>
          <ImgResponsive src={ads2} alt="Slide 2" />
        </div>
        <div>
          <ImgResponsive src={ads3} alt="Slide 2" />
        </div>
        <div>
          <ImgResponsive src={ads4} alt="Slide 2" />
        </div>
        <div>
          <ImgResponsive src={ads5} alt="Slide 2" />
        </div>
      </Slider>
    </Box>
  );
};

export default CarouselReview;
